import { Body, SmallBody } from '@indigo-ag/component-module';
import i18next from 'core/i18n';
import React from 'react';

import { date } from 'shared/utils';

interface BackgroundCheckFileProps {
  accessibleUrl?: string;
  createdAt: Date;
  fileName: string;
}

export const BackgroundCheckFile: React.FunctionComponent<BackgroundCheckFileProps> = ({
  accessibleUrl,
  createdAt,
  fileName
}) => (
  <>
    <Body noWrap={true} letMeMargin>
      {accessibleUrl ? (
        <a download href={accessibleUrl} rel="external">
          {fileName}
        </a>
      ) : (
        fileName
      )}
    </Body>
    <SmallBody letMeMargin>{i18next.t('retrievedDate', { date: date.formatDate(createdAt) })}</SmallBody>
  </>
);
